import React, { useState } from "react";
import { troubleshootingItems } from "../electronicsKitData";
import { Wrench, CheckCircle, HelpCircle, AlertCircle } from "lucide-react";

const TroubleshootingSection = () => {
  const [filterProblem, setFilterProblem] = useState("");

  const filteredItems = troubleshootingItems.filter((item) => {
    if (!filterProblem) return true;
    const q = filterProblem.toLowerCase();
    return (
      item.problem.toLowerCase().includes(q) ||
      item.solution.toLowerCase().includes(q) ||
      item.cause.toLowerCase().includes(q)
    );
  });

  return (
    <section className="section troubleshooting-section" id="troubleshooting">
      <div className="container">
        {/* Section Header */}
        <div className="section-header text-center reveal-triggered fade-up" data-aos="fade-up">
          <div className="section-badge trouble-badge">
            <Wrench size={16} /> 🕵️ Detective Fix Guide
          </div>
          <h2 className="section-title">Not Working? You're a Real Engineer Now! 🛠️</h2>
          <p className="section-subtitle">
            Every great inventor has circuits that need tweaking! Follow our Junior Detective Checklist to solve common mysteries like reversed LEDs or loose wires.
          </p>
        </div>

        {/* Diagnostic Problem-Solution Table / Cards */}
        <div className="trouble-matrix-card reveal-triggered zoom-in" data-aos="zoom-in" data-aos-delay="100">
          <div className="trouble-table-responsive">
            <table className="trouble-table">
              <thead>
                <tr>
                  <th style={{ width: "26%" }}>Problem</th>
                  <th style={{ width: "32%" }}>Probable Cause</th>
                  <th style={{ width: "42%" }}>Try This Fix</th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.map((item, index) => (
                  <tr key={index}>
                    <td className="problem-cell">
                      <div className="problem-title-box">
                        <AlertCircle size={16} className="text-red-500 shrink-0" />
                        <strong>{item.problem}</strong>
                      </div>
                    </td>
                    <td className="cause-cell text-slate-600">{item.cause}</td>
                    <td className="solution-cell">
                      <div className="solution-box">
                        <CheckCircle size={16} className="text-emerald-500 shrink-0 mt-0.5" />
                        <span>{item.solution}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Warm Battery Emergency Callout */}
        <div className="battery-warning-banner reveal-triggered fade-up delay-200" data-aos="fade-up">
          <div className="warning-icon">🔥</div>
          <div className="warning-content">
            <h4>Important: What if the battery feels warm?</h4>
            <p>
              <strong>Unclip it right now!</strong> This means a short circuit is occurring—the red and black wire tips
              are directly touching each other without going through a component. Separate the wires, let the battery
              cool down, and inspect your circuit connections.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TroubleshootingSection;
